import { useTranslation } from "react-i18next";
import { InlineNotification } from "@carbon/react";

/** The signup error banner (Carbon) — e.g. duplicate email / TAX ID. */
export default function Error() {
  const { t } = useTranslation();
  return (
    <InlineNotification
      kind="error"
      lowContrast
      hideCloseButton
      title={t("register.form.error")}
    />
  );
}
